// src/services/TenantService.ts
import {
  collection,
  doc,
  getDoc,
  getDocs,
  query,
  setDoc,
} from "firebase/firestore";
import { db } from "../firebase";
import { Tenant } from "../models/Tenant";
import { getSubdomainFromUrl } from "../utils/url";

const tenantCollectionRef = collection(db, "tenants");

export const TenantService = {
  async getTenant(): Promise<Tenant | null> {
    try {
      const tenantId = getSubdomainFromUrl(window.location.href);
      const snapshot = await getDoc(doc(tenantCollectionRef, tenantId));
      if (snapshot.exists()) {
        return { _id: snapshot.id, ...snapshot.data() } as Tenant;
      }
      return null;
    } catch (error) {
      console.error(`Error fetching tenant:`, error);
      throw new Error(`Failed to get matter events: ${error}`);
    }
  },

  async updateTenant(
    tenantId: string,
    updatedData: Partial<Omit<Tenant, "_id">>,
  ): Promise<void> {
    await setDoc(doc(tenantCollectionRef, tenantId), updatedData, {
      merge: true,
    });
  },
};
